(function (angular, location) {
  "use strict";

  angular.module("Toyota.Directives").directive("tyOrderAndCollect", [
    "Location",
    "Dealer",
    "UrlParser",
    "DebugLogger",
    "SitecoreAnalytics",
    "GenerateUuid",
    function (Location, Dealer, UrlParser, DebugLogger, SitecoreAnalytics, GenerateUuid) {
      var controller = [
        "$scope",
        function ($scope) {
          var ctl = this;
          var loadingCount = 0;

          $scope.isOrderAndCollectEnabled = false;
          $scope.url = "";
          $scope.target = $scope.alternateTarget !== null ? $scope.alternateTarget : "_blank";
          $scope.role = typeof $scope.role !== "undefined" ? $scope.role : null;
          ctl.init = function () {
            $scope.$on("GeoPostCode", function (event, postcode) {
              $scope.hasLocation = postcode !== "";
            });

            $scope.$on("did-location-change-dealers-load-begin", function () {
              startLoading();
            });

            $scope.$on("did-location-change-dealers-load-end", function () {
              ctl.updateDealer();
              stopLoading();
            });

            $scope.$on("saved-dealer-with-default-fallback-did-change", function () {
              ctl.updateDealer();
            });

            $scope.$watch(
              "materialCode",
              function (newValue, oldValue) {
                if (newValue !== oldValue) {
                  ctl.updateDealer();
                }
              },
              true
            );
          };

          ctl.updateLoading = function (_loading) {
            $scope.loading = _loading;

            if (typeof $scope.onDidLoadingInitOrChange === "function") {
              $scope.onDidLoadingInitOrChange($scope.id, _loading);
            }
          };

          ctl.updateDealer = function () {
            var dealer = Dealer.getSavedFallbackToDefault();
            $scope.dealer = dealer;
            $scope.hasDealer = dealer && dealer.branchCode;
            if (ctl.hasOrderAndCollectService()) {
              ctl.fetchUrl();
            } else {
              $scope.url = $scope.alternateUrl;
            }
          };

          ctl.triggerGoal = function (goalId) {
            SitecoreAnalytics.triggerGoal(goalId);
          };

          function startLoading() {
            loadingCount++;
            DebugLogger.log("tyOrderAndCollect", "startLoading()", $scope.id, loadingCount);
            ctl.updateLoading(loadingCount > 0);
          }

          function stopLoading() {
            loadingCount = Math.max(loadingCount - 1, 0);
            DebugLogger.log("tyOrderAndCollect", "stopLoading()", $scope.id, loadingCount);
            ctl.updateLoading(loadingCount > 0);
          }

          ctl.hasOrderAndCollectService = function () {
            if ($scope.dealer) {
              $scope.isOrderAndCollectEnabled = $scope.dealer.orderAndCollectFlag;
              return $scope.dealer.orderAndCollectFlag;
            }

            return undefined;
          };

          ctl.fetchUrl = function () {
            if (!ctl.hasAllData()) {
              return;
            }

            $scope.url = null;
            $scope.isOrderAndCollectEnabled = false;

            var dealer = Dealer.getSavedFallbackToDefault();
            if (!ctl.isValidOmnichannelUrl(dealer)) {
              return;
            }

            var orderAndCollectURL = dealer.orderAndCollectURL + $scope.omnichannelUrl;
            $scope.url = ctl.urlWithCampaignTracking(
              orderAndCollectURL,
              $scope.materialCode,
              $scope.utmMedium,
              $scope.utmTerm
            );
            $scope.isOrderAndCollectEnabled = true;
          };

          ctl.isValidOmnichannelUrl = function (dealer) {
            var hasValidOrderAndCollectUrl =
              dealer &&
              dealer.orderAndCollectFlag &&
              dealer.orderAndCollectURL !== null &&
              dealer.orderAndCollectURL.length > 0;

            if (!hasValidOrderAndCollectUrl) {
              return false;
            }

            var omnichannelUrlPath = document.createElement("a");
            omnichannelUrlPath.href = dealer.orderAndCollectURL + $scope.omnichannelUrl;

            return (
              omnichannelUrlPath.protocol &&
              omnichannelUrlPath.host &&
              omnichannelUrlPath.host !== location.host &&
              omnichannelUrlPath.pathname
            );
          };

          ctl.urlWithCampaignTracking = function (url, materialCode, utmMedium, utmTerm) {
            var newAttributes = {
              m: materialCode,
              utm_source: "toyota_com_au",
              utm_medium: utmMedium,
              utm_campaign: "omni_integration",
              utm_term: utmTerm,
              utm_content: location.href,
            };
            return UrlParser.overrideUrlQueryStringFromMap(url, newAttributes);
          };

          ctl.getShouldShow = function () {
            if ($scope.role === "BookATestDrive") {
              return !$scope.isOrderAndCollectEnabled;
            }

            if ($scope.role === "OrderAndCollect") {
              return $scope.isOrderAndCollectEnabled;
            }

            return true;
          };

          ctl.hasAllData = function () {
            return $scope.hasLocation && $scope.hasDealer && !!$scope.materialCode;
          };

          ctl.init();
        },
      ];

      return {
        scope: {
          materialCode: "<tyOrderAndCollectMaterialCode",
          role: "@tyOrderAndCollectRole",
          onDidLoadingInitOrChange: "<tyOrderAndCollectOnDidLoadingInitOrChange",
          utmTerm: "@utmTerm",
          utmMedium: "@utmMedium",
          omnichannelUrl: "@tyOrderAndCollectUrl",
          alternateUrl: "@tyOrderAndCollectAlternateUrl",
          alternateTarget: "@tyOrderAndCollectAlternateTarget",
        },
        restrict: "A",
        controller: controller,
        controllerAs: "tyOrderAndCollectController",
        replace: true,
        transclude: true,
        // prettier-ignore
        template:
          '<span class="ty-order-and-collect" ' +
                "data-ng-class=\"{'is-omni-channel' : isOrderAndCollectEnabled }\" " +
                'data-ng-show="tyOrderAndCollectController.getShouldShow()">' +
          "</span>",
        link: function (scope, element, attrs, ctrl, transclude) {
          transclude(scope, function (clone) {
            element.empty().append(clone);
          });

          angular.extend(scope, {
            id: GenerateUuid(),
            loading: undefined,
            hasLocation: Location.get().postcode !== "",
            hasDealer: Dealer.getSavedFallbackToDefault().branchCode !== "",
            dealer: Dealer.getSavedFallbackToDefault(),
            error: false,
          });

          setTimeout(function () {
            scope.tyOrderAndCollectController.updateDealer();
            scope.tyOrderAndCollectController.updateLoading(false);
          }, 0);
        },
      };
    },
  ]);
})(window.angular, window.location);
